var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","key":0}),React.createElement("polyline",{"points":"7 10 12 15 17 10","key":1}),React.createElement("line",{"x1":"12","y1":"15","x2":"12","y2":"3","key":2})]);
}

IconDownload.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-download"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
